<template>
	<el-dialog class="couponDialog" :visible="show" append-to-body @close="handleClose" @open="handleCoupon">
		<div slot="title">
			<div class="dislogTitle">
				优惠券
			</div>
		</div>
		<div class="dislogConent">
			<el-tabs v-model="activeName" @tab-click="handleCoupon">
				<el-tab-pane :label="`全部（${allCoupon}）`" name="0"></el-tab-pane>
				<el-tab-pane :label="`可用 (${couponData.ky_count ? couponData.ky_count : 0})`" name="1"></el-tab-pane>
				<el-tab-pane :label="`已使用 (${couponData.yy_count ? couponData.yy_count : 0})`" name="2"></el-tab-pane>
				<el-tab-pane :label="`已过期 (${couponData.gq_count ? couponData.gq_count : 0})`" name="3"></el-tab-pane>
			</el-tabs>
			<div class="couponList" v-if="couponData.list && couponData.list.length > 0">
				<div class="coupon" v-for="(item,index) in couponData.list" :key="index" @click="chooseCoupon(item)">
					<img class="bgIcon" src="../assets/BuyNow/iconK.png"
						v-if="item.status == 1 && item.out_status == 1" />
					<img class="bgOtherIcon" src="../assets/BuyNow/iconL.png" v-else />
					<div class="price">
						<span class="unit" v-if="item.v_type == 1">¥</span>
						{{item.v_type == 1 ? (item.original_price * 1).toFixed(0) : ((item.original_price * 1).toFixed(0) + '折')}}
					</div>
					<div class="couponInfp">
						<div class="desc">
							{{item.v_type == 1 ? `满${item.max_price}减${item.original_price}` : `满${item.max_price}可使用`}}
						</div>
						<div class="type">全场通用</div>
						<div class="choose">选择</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			params: {
				type: Object,
				default: () => {}
			},
			methodName: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				couponData: {},
				activeName: '0',
			}
		},
		computed: {
			allCoupon() {
				let total = 0
				if (this.couponData.gq_count) {
					total = total + this.couponData.gq_count
				}
				if (this.couponData.ky_count) {
					total = total + this.couponData.ky_count
				}
				if (this.couponData.yy_count) {
					total = total + this.couponData.yy_count
				}
				return total
			},
		},
		methods: {
			handleClose() {
				this.activeName = '0'
				this.couponData = {}
				this.$emit('close')
			},
			chooseCoupon(item) {
				if (item.status == 1 && item.out_status == 1) {
					this.$emit('update', item)
					this.handleClose()
				}
			},
			handleCoupon() {
				const data = {
					...this.params,
					status: this.activeName == '0' ? '' : this.activeName,
				}
				this.$api.post(this.methodName, data).then(res => {
					if (res.code == 1) {
						this.couponData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},

		}
	}
</script>

<style lang="scss" scoped>
	.couponDialog {

		::v-deep .el-dialog {
			width: 6.08rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem .12rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .12rem 0 .24rem;

				.couponList {
					display: flex;
					flex-wrap: wrap;
					width: 100%;
					height: 3.2rem;
					overflow-y: auto;

					.coupon:nth-child(2n) {
						margin-right: 0;
					}

					.coupon {
						margin-right: .16rem;
						margin-bottom: .16rem;
						width: 2.7rem;
						height: .92rem;
						display: flex;
						align-items: center;
						position: relative;
						cursor: pointer;

						.bgIcon {
							position: absolute;
							top: 0;
							left: 0;
							width: 2.70;
							height: .92rem;
						}

						.bgOtherIcon {
							position: absolute;
							top: 0;
							left: 0;
							width: 2.70;
							height: .92rem;
							z-index: 2;
						}

						.price {
							width: .92rem;
							display: flex;
							align-items: baseline;
							justify-content: center;
							font-weight: 700;
							font-size: .4rem;
							color: #000000;
							z-index: 1;

							.unit {
								font-weight: 400;
								font-size: .14rem;
							}
						}

						.couponInfp {
							margin-left: .16rem;
							display: flex;
							flex-direction: column;
							z-index: 1;

							.desc {
								font-weight: 700;
								font-size: .14rem;
								color: #000000;
								line-height: .2rem;
							}

							.type {
								margin-top: .04rem;
								font-weight: 400;
								font-size: .12rem;
								color: #000000;
							}

							.choose {
								margin-top: .04rem;
								width: .56rem;
								height: .26rem;
								background: #E29358;
								box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
								border-radius: .06rem;
								font-weight: 400;
								font-size: .12rem;
								color: #252525;
								line-height: .26rem;
								text-align: center;
							}
						}
					}
				}
			}
		}
	}

	::v-deep .el-tabs {

		&__header {
			margin: 0 0 .16rem;
		}

		&__active-bar {
			background-color: #693200 !important;
		}

		&__item {
			height: .4rem;
			padding: 0 .2rem;
			font-weight: 400;
			font-size: .16rem;
			color: #666666 !important;
			line-height: .4rem;

			&:hover {
				color: #693200 !important;
			}
		}

		&__nav-wrap::after {
			height: .01rem;
		}

		.is-active {
			font-weight: 500;
			color: #693200 !important;
		}
	}
</style>